import { io } from 'socket.io-client';

const socket = io('https://apps.isepsantafe.com.ar', {
  autoConnect: false, // importante
});

export const conectarSocket = (user) => {
  socket.auth = {
    dni: user.dni, // 👈 CLAVE
  };

  socket.connect();
};

// LOGS
socket.on("connect", () => {
//   console.log("🟢 Socket conectado");
//   console.log("ID:", socket.id);
});

socket.on("disconnect", (reason) => {
//   console.log("🔴 Socket desconectado");
//   console.log("Motivo:", reason);
});

socket.on("connect_error", (error) => {
//   console.log("⚠️ Error de conexión");
//   console.log(error.message);
});

socket.on("reconnect_attempt", (attempt) => {
//   console.log("🔄 Intento de reconexión:", attempt);
});
let estadoConexion = "offline";

socket.on("connect", () => {
  estadoConexion = "online";
//   console.log("🟢 Socket conectado");
});

socket.on("disconnect", (reason) => {
  estadoConexion = "offline";
//   console.log("🔴 Socket desconectado:", reason);

  // 👇 NO reconectamos automático si fue el server
  if (reason !== "io server disconnect") {
//     console.log("♻️ Reconexión automática...");
  }
});

export const getEstadoSocket = () => estadoConexion;
export default socket;